import { apiPage, apiRequest } from '@/api/client';
import type { BulkRunView, TemplateFamilyView, TemplateVersionView } from '@/types/api';

/** Template versions a site is created from. */
export const templatesApi = {
  list: (cursor?: string | null) =>
    apiPage<TemplateVersionView>(`/templates?limit=100${cursor ? `&cursor=${cursor}` : ''}`),

  deprecate: (id: string) =>
    apiRequest<TemplateVersionView>(`/template-versions/${id}/deprecate`, { method: 'POST' }),

  /** Templates as people think of them (ADR-0047): one name, its versions and sites. */
  families: () => apiRequest<TemplateFamilyView[]>('/template-families'),

  /** A version to every site of the template that is behind it. */
  rollout: (templateId: string, versionId: string) =>
    apiRequest<BulkRunView>(`/template-families/${templateId}/rollout`, { method: 'POST', body: { versionId } }),
};
